/**
 * Set cookie with expiration
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Number of days until expiration
 */
function fnSetCookie(name, value, days) {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + days);
  const cookieValue =
    encodeURIComponent(value) +
    (days ? `;expires=${expirationDate.toUTCString()}` : "") +
    ";path=/";
  document.cookie = `${name}=${cookieValue}`;
}

/**
 * Get cookie by name
 * @param {string} name - Cookie name
 * @returns {string|null} - Cookie value or null if not found
 */
function fnGetCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0)
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}

/**
 * Save and restore scroll position for projects page
 */
function fnSaveScrollPosition() {
  // Skip clear when clicking on project card links or back button
  $(document).on(
    "click",
    "section.project-hero .back-btn a, article.project-card a",
    () => {
      window.skipClear = true;
    }
  );

  // Save scroll position when clicking on project card links
  $(document).on("click", "article.project-card a", function (e) {
    e.preventDefault();
    const scrollPosition = window.scrollY || window.pageYOffset;

    const urlParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of urlParams.entries()) {
      if (key == "sf_paged") continue;
      params[key] = value;
    }

    const queryString = Object.keys(params)
      .map((key) => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
      })
      .join("&");

    fnSetCookie("projectsFilterParams", `/projects/?${queryString}`, 1);

    localStorage.setItem(
      "projectsScrollPosition",
      JSON.stringify({
        scrollPosition: scrollPosition,
        html: $("#projects-listing").html(),
      })
    );
  });

  // Remove scroll position when reloading page
  window.addEventListener("beforeunload", function () {
    if (!window.skipClear) {
      localStorage.removeItem("projectsScrollPosition");
      window.scrollTo({
        top: 0,
        behavior: "auto",
      });
    }
  });

  // Restore scroll position when returning to projects page
  if (document.body.classList.contains("post-type-archive-project")) {
    const saved = localStorage.getItem("projectsScrollPosition");
    if (!saved) return;

    const savedObj = JSON.parse(saved);

    const savedPosition = savedObj.scrollPosition;

    if (savedPosition) {
      // Use setTimeout to ensure the page is fully loaded before scrolling
      setTimeout(() => {
        $("#projects-listing").html(savedObj.html);
        jQuery(".searchandfilter").trigger("projects:ajaxfinish");
        window.scrollTo({
          top: parseInt(savedPosition),
          behavior: "auto",
        });
      }, 100);
    }
  }
}

(function ($) {
  "use strict";

  /**
   * Initiate independent functions
   */
  function fnInit() {
    fnServicesAccordion();
    fnInViewDetect();
    //gsap.registerPlugin(ScrollTrigger);
    $("body").addClass("page-loaded"); // Page loaded class

    //  Nuclear option, remove the page transition after 2 seconds
    setTimeout(function () {
      $("body.home .page-transition").fadeOut(function () {
        $(this).remove();
      }); // Instagram Section Reveal with Scroll Magic
    }, 2000);

    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link tacco anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(fnScrollToID); // Smooth anchor links
    fnCursor(); // Custom cursor (run after all slick carousels)
    if (!fnInitLazyLoad()) {
      var lazyLoadAttempts = 0;
      var lazyLoadRetry = setInterval(function () {
        if (fnInitLazyLoad() || ++lazyLoadAttempts >= 50) {
          clearInterval(lazyLoadRetry);
        }
      }, 100);
    }
    $("video.video").each(fnResponsiveVideoLoading); //	Video Load

    $(".paroller, [data-paroller-factor]").each(fnParallax); // Paroller (parallax)
    $("section.posts-carousel").each(fnPostsCarousel); // Posts carousel
    $("section.featured-projects").each(fnPostsCarousel); // Projects carousel
    $("section.faq-carousel").each(fnFaqCarousel); // FAQ carousel
    $("section.gallery-slider").each(fnGallerySlider); // Gallery Slider
    $("section.testimonials-slider").each(fnTestimonialsSlider); // Testimonials Slider
    $("section.team-carousel").each(fnTeamCarousel); // Team Carousel
    $("section.sustainable-carousel").each(fnSustainableCarousel); // Sustainable Carousel
    $("section.process-slider").each(fnProcessSlider); // Process Slider
    //$('section.old-featured-projects').each(fnFeaturedProjects);	        // Featured Projects
    $(".accordions").each(fnAccordion); // Accordion
    $(".gform_wrapper").each(fnGform); // Gform
    $("section.projects-archive").each(fnProjectsArchive); // Projects
    $("section.services-accordion").each(fnServicesAccordion);
    $("section.brands").each(fnBrands);
    $("section.accordion").each(fnAccordionAlt);
    $("section.process").each(fnProcess);
    $("section.testimonials-slider-alt").each(fnTestimonialsSliderAlt);
    $("section.projects-hero").each(fnProjectsHero);
    $("section.projects-listing").each(fnProjectsFilter);
    $("section.projects-listing").each(fnProjectsLoadMore);
    $("section.hero-about").each(fnAboutHero);
    $("article.project-card").each(fnProjectItemSlider);
    $("section.stats").each(fnStats);
    $("section.horizontal-slider").each(fnHorizontalSlider);
    $("section.vertical-slider").each(fnVerticalSlider);
    $("section.scrolling-text-videos").each(fnScrollingTextVideos);
    $("section.people-carousel").each(fnPeopleCarousel);
    $("section.hero-services").each(fnServicesHero);
    $("section.full-width-video").each(fnFullWidthVideo);
    fnSaveScrollPosition(); // Save and restore scroll position
    fnMarketingCta(); // Marketing CTA
    fnDownloadFormPopup(); // Download Form Popup

    $(document).on(
      "sf:ajaxfinish projects:ajaxfinish",
      ".searchandfilter",
      function () {
        $("section.projects-listing").each(fnProjectsFilter);
        $("section.projects-listing").each(fnProjectsLoadMore);
        $("article.project-card").each(fnProjectItemSlider);
        fnInitLazyLoad();
        $("video.video").each(fnResponsiveVideoLoading);
      }
    );

    fnAjaxPostsFilter(); // Posts Filter Ajax
    fnHamburgerMenu(); // Header Hamburger Menu
    fnColorScheme();

    $(".dropkick select").dropkick({ mobile: true }); // Select drop-down styling (Dropkick.js)

    $(document).on('gform_page_loaded', function(event) {
      $(".dropkick select").dropkick({ mobile: true });
    });

    fnMagnetize(); // Magnetize elements on hover

    fnBgTransitions(); // Home Background Transitions

    setTimeout(function () {
      fnInstagramSection(); // Instagram Section Reveal with Scroll Magic
    }, 4000);

    if (document.querySelector(".page-template-template_services_v2")) {
      $("body").addClass("scrolled");
    }

    if (document.querySelector(".page-template-template_contact")) {
      $("body").addClass("scrolled");
    }

    jQuery('section.contact-hero').each(function() {
      const $this = jQuery(this);

      $this.on('click', '.accordion-header', function() {
        jQuery(this).parent().toggleClass('active').find('.accordion-content').slideToggle().parent().siblings().removeClass('active').find('.accordion-content').slideUp();
      })
    })

    //Scroll detection
    var lastScrollTop = 0;
    $(window).scroll(function (event) {
      if (
        !document.querySelector(
          ".page-template-template_services_v2, .page-template-template_contact"
        )
      ) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
          $("body").addClass("scrolled");
          // downscroll code
          if ($(document).scrollTop() > 500) {
            $("body").removeClass("scroll-up").addClass("scrolled scroll-down");
          }
        } else {
          // upscroll code
          $("body").removeClass("scroll-down").addClass("scrolled scroll-up");
        }

        // scroll top position
        if ($(document).scrollTop() === 0) {
          $("body").removeClass("scrolled");
        }

        lastScrollTop = st;
      } else {
        $("body").addClass("scrolled");
      }
    });

    /*Pages Transition*/
    $("body").on(
      "click",
      'a:not([href^="#"], [href^="tel"], [href^="mailto"], .video-popup)',
      function (ev) {
        /*Check Location with the same hostname*/
        if (location.hostname === this.hostname || !this.hostname.length) {
          var sUrl = this.href;
          ev.preventDefault();

          /*Change preloader bg depending on page redirecting to*/
          if (
            sUrl.indexOf("/sector/") >= 0 ||
            sUrl.indexOf("/projects/") >= 0 ||
            sUrl.indexOf("/project/") >= 0
          ) {
            $(".page-transition").css("background-color", "#17181D");
          } else {
            if (
              $(
                "body.single-project, body.page-template-template_projects, body.tax-sector"
              )
            ) {
              $("body").addClass("blue");
            }
          }

          $("body").addClass("redirecting");

          /*delay while page transition animations works*/
          setTimeout(function () {
            window.location.href = sUrl;
          }, 800);
        }
      }
    );

    //Comparison Slider
    document.querySelectorAll(".cocoen").forEach(function (element) {
      new Cocoen(element);
    });

    //Home Hero Media Pairs Display
    $(".hero-home").each(function () {
      const oMediaLeft = $(".media-left .media", this),
        oMediaRight = $(".content-right-inner .media", this),
        timeout = 4000,
        carouselFn = (items) => {
          if (items.length <= 1) return;
          let currentIdx = 0;

          items.each(function (idx) {
            var el = jQuery(this);

            if (el.is(":visible")) currentIdx = idx;
          });

          items.eq(currentIdx).fadeOut(600);
          items
            .eq(currentIdx + 1 < items.length ? currentIdx + 1 : 0)
            .fadeIn(600);
        };

      oMediaLeft.eq(0).fadeIn();
      oMediaRight.eq(0).fadeIn();

      setInterval(() => {
        carouselFn(oMediaLeft);
        carouselFn(oMediaRight);
      }, timeout);
    });

    // Split text by lines
    $(".line-split").each(function () {
      var oTarget = $(this),
        oResults = Splitting({ target: oTarget, by: "lines" });
      fnSplittedTextReveal(oTarget, oResults);
      $(document).on("scroll", function () {
        fnSplittedTextReveal(oTarget, oResults);
      });
    });

    //Splitted Text Reveal
    function fnSplittedTextReveal(oTarget, oResults) {
      var oTitlesGroup = oTarget.parents("hgroup, .two-columns-intro"),
        iCoeff = 0;
      if (oTitlesGroup.hasClass("in-view") && !oTarget.hasClass("revealed")) {
        if (oTitlesGroup.hasClass("first-screen")) {
          iCoeff = 1.5;
        }
        oResults[0].lines.forEach((line, index) => {
          line.forEach((word) => {
            gsap.from(word, {
              opacity: 0,
              y: 50,
              delay: index / 4 + iCoeff,
              duration: 0.7,
            });
          });
        });
        oTarget.addClass("revealed");
      }
    }

    //Position aware effect for button
    $(".button-bordered, .button-bordered-white")
      .on("mouseenter", function (e) {
        var parentOffset = $(this).offset(),
          relX = e.pageX - parentOffset.left,
          relY = e.pageY - parentOffset.top;
        $(this).find("span.hover").css({ top: relY, left: relX });
      })
      .on("mouseout", function (e) {
        var parentOffset = $(this).offset(),
          relX = e.pageX - parentOffset.left,
          relY = e.pageY - parentOffset.top;
        $(this).find("span.hover").css({ top: relY, left: relX });
      });

    fnAnimations(); // Gsap Animations

    if (document.querySelector(".page-template-template_promo_landing")) {
      const items = document.querySelectorAll(".eventDatesItem");
      let currentItem = 0;

      function showNextItem() {
        items[currentItem].classList.remove("active"); // Remove active class

        currentItem = (currentItem + 1) % items.length;

        // Reset currentItem to 0 if it reaches the end
        if (currentItem === items.length) {
          currentItem = 0;
        }

        items[currentItem].classList.add("active"); // Add active class
      }

      // Initial display (fix 1)
      items[currentItem].classList.add("active"); // Ensure initial display

      // Call showNextItem immediately to start the loop (fix 2)
      showNextItem();

      setInterval(showNextItem, 5000);
    }
  }

  fnInit();
})(jQuery);
